import * as Sentry from '@sentry/vue'
import Utils from '@/util'
import Constants from '@/constant'
import Socket from '@/socket'
import SlideApi from '@/api/slide'
import PresentationApi from '@/api/presentation'
import EventBus from '@/eventBus'
import store from '@/vuex/store'

export default {

  /**
     * This method affect logic of the right tab when reload the presentation
     * It seems that for most type of slide, the activeTab is `Content`
     * or for the rest the activeTab is `Type`
     * @param {*} isNewPresentation
     * @param {*} sharePresentation
     * 2 above parameters are used for edge cases I don't understand
     * @param {*} _dispatch: $store.dispatch function to apply the change
     * @param {*} res: the response for presentation data from server
     */

  handleActiveTab(editor, _dispatch, res) {
    const { isNewPresentation, sharePresentation } = editor
    const hasSlidesWithNoType = res.body && res.body.slides && res.body.slides.length &&
      isNewPresentation && !res.body.slides[0].type
    const hasSlidesWithNoActiveSlide = res.body && res.body.slides &&
      !res.body.activeSlide && res.body.slides.length
    const hasNoRightNavActiveTab = !editor.rightNavActiveTab || !editor.rightNavActiveTab.length

    if ((hasSlidesWithNoType || hasSlidesWithNoActiveSlide) && hasNoRightNavActiveTab) {
      editor.showSlideTypeSelectionAction()
    }
    if (res.body.activeSlide) {
      this._setActiveTabWhenHasActiveSlide(editor, sharePresentation, _dispatch, res)
    } else {
      _dispatch('setSlideActive', res.body.slides[0])
    }
  },

  _setActiveTabWhenHasActiveSlide(editor, sharePresentation, _dispatch, res) {
    let activeSlide = null
    if (store.state.powerPointPresentationId === res.body.id && store.state.powerPointSlideId) {
      activeSlide = store.state.powerPointSlideId
    } else {
      activeSlide = res.body.activeSlide
    }

    const index = res.body.slides.findIndex((item) => {
      return item.id == activeSlide
    })

    if (index != -1) {
      if (sharePresentation) {
      // FIXME: cần sửa loại đoạn code này cho đẹp hơn, đoạn code này đang
      // là cách fix tạm thời từ tech debt https://ahaslides.atlassian.net/browse/AHA-6095
      // Vì hiện tại đang bị duplicate gọi API trên màn hình sharing nên
      // khi load xong data cần gọi đến hàm set slide active
      // thay vì update để đảm bảo các component đc render đúng.
        _dispatch('updateSlideActive', {
          id: null,
        })
      }
      _dispatch('setSlideActive', res.body.slides[index])
    }
  },

  setPrezFontFamily: (fontFamily) => {
    if (!fontFamily) return
    if (fontFamily && fontFamily != 'nunito') {
      Utils.setFontSlideV2(fontFamily)
    }
  },

  getAudienceOnline: (res, slideActive, presentation) => {
    const isPresentingQuizOrSpinnerWheel = (slideActive.type === 'pickAnswer' &&
    presentation.presenting) || slideActive.type === 'spinnerWheel'
    if (!isPresentingQuizOrSpinnerWheel) return
    try {
      PresentationApi.getAudienceOnline({
        accessCode: res.body.uniqueAccessCode,
      })
    } catch (error) {
      Sentry.captureException(error)
    }
  },

  setPresentationSockets: (currentUser) => {
    if (!currentUser) return {}
    const {
      id, avatar, firstName, lastName, email, accountRole,
    } = currentUser
    return {
      id,
      avatar,
      name: lastName ? `${firstName} ${lastName}` : firstName,
      socketId: Socket.getSocketId(),
      email,
      accountRole,
    }
  },

  setOnlineStatus: (currentUser, sharePresentation, userOnline, onlineStatus, plan) => {
    let result = 0
    if (!currentUser.id) return result
    if (!sharePresentation) {
      const percentLimit =
          (userOnline / plan.limit) * 100

      if (percentLimit > 75 && percentLimit < 95) {
        result = 2
      }
      if (percentLimit >= 95) {
        result = 3
      }
      if (percentLimit <= 75 && onlineStatus != 1) {
        result = 1
      }
    } else {
      result = 1
    }
    return result
  },

  setPresentationLanguage: (res, _dispatch) => {
    if (!res.body.language) {
      res.body.language = 'en'
    }
    _dispatch('setLang', res.body.language)
  },

  setBrowserTitle: (res, isPresenterWhiteLabel, isBackstage) => {
    if (!isPresenterWhiteLabel) {
      window.document.title = `${res.body.name} - AhaSlides`
    }

    if (isBackstage) {
      window.document.title = `Backstage of ${res.body.name}`
      store.dispatch('preventLockScreen/requestWakeLockAction')
    }
  },

  _getSlideType(slide) {
    if (!slide.slideType) slide.slideType = null
    let obj = {}
    const allTypeSections = store.getters['slideTypeList/getSlideTypeList']
    allTypeSections.forEach((item) => {
      item.slideTypes.forEach((typeObj) => {
        if (!typeObj.slideType) typeObj.slideType = null
        if (
          typeObj.type == slide.type &&
          typeObj.slideType == slide.slideType
        ) {
          obj = typeObj
        }
      })
    })
    return obj
  },

  sortAndUpdateSlides(res, editor) {
    if (!res.body.slides) return
    if (editor.isNewPresentation) {
      res.body.slides[0].type = ''
    }
    this._setSlidesOtherSettings(res)

    res.body.slides.sort((a, b) => {
      return a.order - b.order
    })
    this._updateNextSlide(res, editor, editor.slideActive,
      editor.sharePresentation, editor.$route.params.id)
    this._setSlideSettingsWhenSharePresentation(res, editor.sharePresentation)
  },

  _setSlidesOtherSettings(res) {
    res.body.slides.forEach((item) => {
      if (!item.multipleCountAnswer) item.multipleCountAnswer = 0
      item.voteCache = item.multipleCountAnswer
      if (item.type) {
        item.typeObj = this._getSlideType(item)
      }

      try {
        if (item.additionalFields) {
          item.additionalFields = JSON.parse(item.additionalFields)
        } else {
          item.additionalFields = []
        }
      } catch (error) {
        item.additionalFields = []
        Sentry.captureException(error)
      }

      try {
        if (item.otherCorrectQuiz) {
          item.otherCorrectQuiz = JSON.parse(item.otherCorrectQuiz)
        } else {
          item.otherCorrectQuiz = []
        }
      } catch (error) {
        item.otherCorrectQuiz = []
        Sentry.captureException(error)
      }

      item.SlideOptions.sort((a, b) => {
        if (item.type == 'openEnded') {
          return Utils.sortOptionsByDate(a, b)
        }
        return a.order - b.order
      })
      if (item.hints && item.hints.length) {
        item.hints.sort((a, b) => {
          return a.order - b.order
        })
      }
    })
  },

  _updateNextSlide: async (res, editor, slideActive, sharePresentation, routerId) => {
    const editorHasSlidesWithNoActiveSlide =
      !res.body.activeSlide && res.body.slides.length && !sharePresentation
    if (!editorHasSlidesWithNoActiveSlide) return

    try {
      await SlideApi.updateNextSlideById(routerId, {
        activeSlide: res.body.slides[0].id,
        accessCode: res.body.uniqueAccessCode,
        from: 'PresentationDetailUtils',
        presentationId: res.body.id,
      })
    } catch (error) {
      if (Sentry && error.status) {
        Sentry.captureException(`Presenter put next slide main, status: ${error.status}`)
      }
    }

    editor.$store.dispatch('checkSlideMovingDirectionAction', slideActive.id)
  },

  _setSlideSettingsWhenSharePresentation(res, sharePresentation) {
    if (!sharePresentation) return
    res.body.slides.forEach((item) => {
      item.hideResult = false
      item.showAllBulletPoints = true
      item.showCorrectOption = true
      if (item.image && item.type !== 'ideas') {
        item.showQuestionImage = true
      }
      if (item.type === 'ideas') {
        item.showQuestionImage = false
        item.votingStep = Constants.IdeasTabName.RESULT
      }
    })
    res.body.activeSlide = res.body.slides[0].id
  },

  detectScreenAndSetTransition: () => {
    setTimeout(() => {
      EventBus.$emit('detectScreen')
      EventBus.$emit('eventHandleSetValueTransition')
    }, 500)
  },
}
